<template>
  <div>
    <!-- <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
      </a-tab-pane>
    </a-tabs> -->
    <div style="margin: 12px 0; color: #ee822f; font-size: 14px">
      *班主任老师您好，以下是经过心理测评筛查出来咱们班有异常的同学名单，希望班主任多进行关注引导。如果与我们的评测观察有额外的信息，请班主任记录。
    </div>
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :isShowEmpty="false"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <div>
          <a-button
            type="primary"
            icon="download"
            style="margin-right: 15px"
            @click="handleExportXls('危机干预学生清单')"
          >
            导出
          </a-button>
        </div>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="viewArchives(record)">我已知晓</span>
          <a-divider type="vertical" />
          <span @click="addCommunicatRecord(record, 'view')">评估记录</span>
        </div>
      </template>
    </TableList>
    <InformationNote ref="informationNoteRef" />
  </div>
</template>
<script>
import TableList from '@comp/chart/TableList.vue'
import { getAction } from '@api/manage'
import { simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal.vue'
import InformationNote from './components/InformationNote.vue'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'ClassMoodDetail',
  components: {
    TableList,
    AssessModal,
    InformationNote,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 1,
      queryParam: {},
      dateRange: [],
      tabPaneConfig: [
        {
          tab: '',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'studentClass',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '班级表现',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '家庭表现',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '备注',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/ddUser/allChildren',
        exportXlsUrl: '/aigoes/schoolWarnRecord/crisisInterventionExport',
      },
      detailModalData: [],
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/aigoes/schoolWarnRecord/getCrisisInterventionList')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
        beginDate: this.dateRange[0] && moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: this.dateRange[1] && moment(this.dateRange[1]).format('YYYY-MM-DD'),
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    viewArchives(record) {},
    addCommunicatRecord(record, type) {
      this.$refs.informationNoteRef.showModal(record, type)
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.action-detail {
  min-width: 100px !important;
  color: #1783e8 !important;
  cursor: pointer !important;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
